const PARIS_TIME_ZONE = "Europe/Paris";

function toDate(input) {
  const date = input instanceof Date ? input : new Date(input);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatParisDateFR(input) {
  const date = toDate(input);
  if (!date) return "";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: PARIS_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const read = (type) => parts.find((part) => part.type === type)?.value;
  return `${read("day")}/${read("month")}/${read("year")}`;
}

export function formatParisTimeFR(input) {
  const date = toDate(input);
  if (!date) return "";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: PARIS_TIME_ZONE,
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const read = (type) => parts.find((part) => part.type === type)?.value;
  return `${read("hour")}:${read("minute")}`;
}

export function formatSessionDate(session) {
  if (session?.playedAt) {
    const formatted = formatParisDateFR(session.playedAt);
    if (formatted) return formatted;
  }
  return session?.date || "—";
}

export function formatSessionTime(session) {
  if (session?.playedAt) {
    const formatted = formatParisTimeFR(session.playedAt);
    if (formatted) return formatted;
  }
  return session?.time || "—";
}
